import "./cases.css";

import c2 from "../../asset-source/vmeste-wjet-cover.jpg";
import c3 from "./img/mini-case3.jpg";
import c4 from "./img/mini-case4.jpg";

function CasesAudit() {
	return (
		<div className="cases__container">
			<h4 className="cases__title">Кейсы</h4>
			<div className="cases__grid">
				<a href="/chin-chin" target="_blank" className="cases__item">
					<img
						src={c4}
						alt="GoChinChin это приложение по поиску встреч и общения с единомышленниками в комфортной и непринужденной атмосфере."
					/>
				</a>
				<a href="/web3-eq-product-page" target="_blank" className="cases__item">
					<img
						src={c3}
						alt="All-in-one DeFi hub of Polkadot. High leverage. Yet resilient"
					/>
				</a>

				<a href="/vmeste" target="_blank" className="cases__item">
					<img
						src={c2}
						alt="Платформа управления работой. Инструменты для планирования, управления проектами и продуктами"
					/>
				</a>
			</div>
		</div>
	);
}

export default CasesAudit;
